<template>
  <ListNote :hasFilterMatter="true" />
</template>

<script>
import ListNote from '@/views/note/Listnote'

// this.$refs.note.query.query = [{ field: 'matter__id',condition: '=' , value: this.$store.state.dashboard_contact_id || this.$route.params.id  }]

export default {
  name: "ListNoteMatter",
  components:{
    ListNote,
  },
}
</script>

<style>
@import "../style/style.css";
.notes{
  text-align: right;
  display: block;
  margin-left: auto;
}
[dir] .ant-card-bordered{
  border-radius: 6px;
}
[dir=ltr] .ant-radio-button-wrapper:first-child{
  border-radius: 3px 0 0 3px;
}
[dir=ltr] .ant-radio-button-wrapper:last-child{
  border-radius: 0 3px 3px 0;
}
.anticon.anticon-check-circle{
  /*color: #3a3dbe!important;*/
}
.ant-table-column-has-actions span{
  white-space: nowrap;
}
@media (max-width: 600px) {
  .tabs-note .ant-tabs-bar.ant-tabs-top-bar{
    display: flex;
    flex-direction: column;
  }
  .ant-tabs-bar.ant-tabs-top-bar .ant-tabs-extra-content{
    padding-bottom: 1.5rem;
  }
  .ant-tabs-extra-content button{
    width: 100%;
    text-align: center;
  }
  .ant-tabs-nav-container{
    text-align: center;
  }
}
@media (max-width: 400px) {
  .ant-radio-group.ant-radio-group-solid{
    display: flex;
    flex-direction: column;
    text-align: center;
  }
  .ant-radio-group.ant-radio-group-solid label{
    margin-bottom: 0.5em;
    border-radius: 3px !important;
  }
}
/*  css general  */

#layout.blog-page{
  background: #696969;
}
#header-container #header .header-wrap>.row:last-child .header-main-panel .header-col-fluid .fixed-header-logo{
  visibility: hidden !important
}
#header-container.small .mobile-logo img{
  position: relative;
  top: 10px;
}

</style>
